import { FillLinkButton } from 'components/Button';
import frontendConfig from 'config/frontend-config';
import NextLink from 'next/link';

interface OrderProps {
  className?: string;
}

const NoOrder: React.FC<OrderProps> = (props) => {
  return (
    <>
      <div className="space-y-6 text-sf-blue-700">
        <div className="overflow-hidden rounded-md bg-sf-gray-100 p-6 text-base">
          <div className="flex flex-col gap-y-3">
            <div>
              <div className="flex flex-col gap-y-2">
                <div className="flex flex-col text-left">
                  <div className="relative flex w-full flex-row flex-nowrap items-start justify-between gap-x-6 font-normal">
                    <div className="text-left">No orders placed</div>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="relative flex w-full flex-row flex-nowrap items-start justify-between gap-x-6 text-sm font-normal">
                    <div className="text-left">{`You don't have any previous orders.`}</div>
                  </div>
                </div>
                <div>
                  <FillLinkButton buttonSize={'none'}>
                    <NextLink href={frontendConfig.shopNowUrlSlug} passHref>
                      <a target={'_self'} className="w-full px-8 py-4 text-center uppercase">
                        Shop our range
                      </a>
                    </NextLink>
                  </FillLinkButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoOrder;
